import MaterialLoader from "../../../output/assets/materials/material-loader.js";

class ThreeGLRaycastMaterialLoader extends MaterialLoader {
    constructor() {
        super();
    }

    load() {
        return createMaterial(false, false, 0);
    }

    unload(material) {
        material.dispose();
    }
}

export default ThreeGLRaycastMaterialLoader;



// Copied from src/Q3/rendering/glraycaster.js

import FRAGMENT_SHADER from "./shaders/glraycaster.fs";
import VERTEX_SHADER from "./shaders/glraycaster.vs"

const USE_LINEAR = true;
const MAX_DISTANCE = 64;
const PRECISION = 20;

const DISTANCE_SCALE = (255 / MAX_DISTANCE).toFixed(PRECISION);
const INVERT_COLOR = (1 / 255).toFixed(PRECISION);

function createMaterial(skinning, morphTargets, clipCount) {
    return new THREE.ShaderMaterial({
        vertexShader: VERTEX_SHADER,
        fragmentShader: FRAGMENT_SHADER,
        // morphTargets: true,

        skinning,
        morphTargets,
        clipping: clipCount > 0,

        uniforms: {
            worldObjectId: { value: 0 }
        },
        defines: {
            EPSILON: 1e-3,
            USE_LINEAR,

            MAX_DISTANCE: MAX_DISTANCE.toFixed(PRECISION),
            DISTANCE_SCALE,
            INVERT_COLOR,
            NUM_CLIPPING_PLANES: clipCount
        }
    });
}
